'use client';

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import { createGlobalStyle } from 'styled-components';
const collapseClassName = 'MeshExpander--collapse';
const quarticEaseOut = 'cubic-bezier(.17, .84, .44, 1)';
const CollapseStyle = createGlobalStyle`
  .${collapseClassName} {
    transition: height 300ms;
    transition-timing-function: ${quarticEaseOut};
  }
`;
function useExpanderLifecycle(_ref) {
  let {
    expanded,
    onExpand,
    onCollapse,
    onBeforeExpand,
    onBeforeCollapse
  } = _ref;
  const [prevExpanded, setPrevExpanded] = useState(expanded);
  if (expanded && !prevExpanded) {
    onBeforeExpand === null || onBeforeExpand === void 0 ? void 0 : onBeforeExpand();
    setPrevExpanded(expanded);
  }
  if (!expanded && prevExpanded) {
    onBeforeCollapse === null || onBeforeCollapse === void 0 ? void 0 : onBeforeCollapse();
    setPrevExpanded(expanded);
  }
  useEffect(() => {
    expanded ? onExpand === null || onExpand === void 0 ? void 0 : onExpand() : onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse();
  }, [expanded]);
}
const Expander = _ref2 => {
  let {
    onExpand,
    onCollapse,
    onBeforeExpand,
    onBeforeCollapse,
    expanded = false,
    id,
    'aria-label': ariaLabel,
    className,
    children,
    ...otherProps
  } = _ref2;
  const [shouldHideChildren, setHideChildren] = useState(!expanded);
  function handleRest() {
    if (!expanded) {
      setHideChildren(true);
    }
  }
  useExpanderLifecycle({
    onExpand,
    onCollapse,
    onBeforeExpand,
    onBeforeCollapse,
    expanded
  });
  useEffect(() => {
    if (expanded) {
      setHideChildren(false);
    }
  }, [expanded]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CollapseStyle, {}), /*#__PURE__*/_jsx("div", {
      id: id,
      "aria-label": ariaLabel,
      hidden: !expanded && shouldHideChildren,
      "data-mesh-component": "EXPANDER",
      children: /*#__PURE__*/_jsx(Collapse, {
        ...otherProps,
        theme: {
          collapse: collapseClassName
        },
        isOpened: expanded,
        "aria-hidden": !expanded,
        onRest: handleRest,
        className: className,
        children: children
      })
    })]
  });
};
export default Expander;